import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { DetalleMensajeDialogComponent } from '../detalle-mensaje-dialog/detalle-mensaje-dialog.component';
import { SharedServices } from 'src/app/shared/shared.service';
import { Router } from '@angular/router';
import { FiltersComponent } from 'src/app/shared/components/filters/filters.component';
import { interval, Subscription, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { isArray } from 'chart.js/dist/helpers/helpers.core';

@Component({
  selector: 'app-history-whatsapp',
  templateUrl: './history-whatsapp.component.html'
})
export class HistoryWhatsapp implements OnInit, OnDestroy {
  displayedColumns: string[] = [
    'telefono',
    'idPaciente',
    'nombresPaciente',
    'eps',
    'habeasData',
    'mensajeBienvenida',
    'tratamientodatos',
    'mensajeDisparador',
    'tratamientoDatosMenorEdad',
    'estadovalidacionpaciente1',
    'estadovalidacionpaciente2',
    'procesoEntrega',
    'entregaExitosa',
    'respuestaCicloUno',
    'acciones'
  ];

  dataSource = new MatTableDataSource<any>([]);
  filterValue = '';
  isLoading: boolean = false
  buttons: any[] = [];
  showFilters: boolean = false;
  filtrosConfig: any[] = [];
  @ViewChild('filtrosComponent') filtrosComponent!: FiltersComponent
  exectQueryFilter: any[] = [];
  private intervalSub!: Subscription;
  private refreshSub?: Subscription;
  private currentPayload: any = { action: 'INFO_MSN_WHATSAPP' };

  anyFilters: any = null;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private dialog: MatDialog,
    private sharedServices: SharedServices,
    private router: Router,

  ) {
    this.buttons = [
      {
        label: 'Filtros',
        icon: '../../../../assets/img/iconos-buttons/filters.png',
        action: 9,
        bgColor: 'bg-color_box',
        disabled: false
      },
      {
        label: 'Limpiar filtro',
        icon: '../../../../assets/img/iconos-buttons/cleanfilter.png',
        action: 7,
        bgColor: 'bg-blue-200',
        disabled: false
      },
      // {
      //   label: 'Descargar Informe',
      //   icon: '../../../../assets/img/iconos-buttons/download.png',
      //   action: 6,
      //   bgColor: 'bg-blue-400',
      // }
    ]

    this.filtrosConfig = [
      {
        id: 1,
        label: 'Id del Caso',
        key: 'idCaso',
        tipo: 'input',
      },
      {
        id: 2,
        label: 'Número de Teléfono',
        key: 'telefono',
        tipo: 'input',
      },
      {
        id: 3,
        label: 'Id del Paciente',
        key: 'numberId',
        tipo: 'input',
      },
      {
        id: 4,
        label: 'Estado',
        key: 'status',
        tipo: 'select-label',
        opciones: [{ label: 'OK', value: '1' }, { label: "PD", value: '0' }]
      },
    ]
  }

  // ngOnInit(): void {
  //   this.cargarData();
  //   this.iniciarAutoRefresh();
  // }

  // cargarData() {
  //   this.isLoading = true;
  //   const data = { action: 'INFO_MSN_WHATSAPP' };

  //   this.sharedServices.postWhatsapp(data).subscribe(res => {
  //     console.log('res',res)
  //     if (res) {
  //       this.dataSource.data = res;

  //       setTimeout(() => {
  //         this.dataSource.paginator = this.paginator;
  //         this.dataSource.sort = this.sort;
  //       });

  //       this.isLoading = false;
  //     }
  //   });
  // }

  // iniciarAutoRefresh() {
  //   this.intervalSub = interval(30000)
  //     .pipe(
  //       switchMap(() => {
  //         const data = { action: 'INFO_MSN_WHATSAPP' };
  //         return this.sharedServices.postWhatsapp(data);
  //       })
  //     )
  //     .subscribe(res => {
  //       if (res) {
  //         console.log('data actualizada', res)
  //         this.dataSource.data = res;
  //       }
  //     });
  // }

  // ngOnDestroy() {
  //   if (this.intervalSub) {
  //     this.intervalSub.unsubscribe();
  //   }
  // }


  ngOnInit(): void {
    this.startAutoRefresh();
  }

  iniciarCargaConAutoRefresh() {
    let data = { action: 'INFO_MSN_WHATSAPP' };
    // console.log(this.anyFilters);
    if (this.anyFilters !== null) {
      data = this.anyFilters;
    }
    this.isLoading = true;

    this.refreshSub = timer(0, 30000)
      .pipe(
        switchMap(() => this.sharedServices.postWhatsapp(data))
      )
      .subscribe({
        next: (res) => {
          if (res) {
            this.dataSource.data = res;

            // Inicializar paginator y sort solo una vez
            if (!this.dataSource.paginator) {
              setTimeout(() => {
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;

              });
            }

            this.isLoading = false;
          }
        },
        error: (err) => {
          console.error('Error cargando WhatsApp info', err);
          this.isLoading = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.stopAutoRefresh();
  }



  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  startAutoRefresh(): void {
    this.stopAutoRefresh();
    this.isLoading = true;

    this.refreshSub = timer(0, 30000)
      .pipe(
        switchMap(() => this.sharedServices.postWhatsapp(this.currentPayload))
      )
      .subscribe({
        next: (res) => {
          const data = Array.isArray(res) ? res : res ? [res] : [];

          this.dataSource.data = data;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;

          if (this.paginator) {
            this.paginator.firstPage();
          }

          this.isLoading = false;
        },
        error: () => {
          this.dataSource.data = [];
          this.isLoading = false;
        }
      });
  }


  stopAutoRefresh(): void {
    if (this.refreshSub) {
      this.refreshSub.unsubscribe();
      this.refreshSub = undefined;
    }
  }


  applyFilter(event: Event): void {
    const value = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.filterValue = value;
    this.dataSource.filter = value;
  }

  clearFilter(): void {
    this.filterValue = '';
    this.dataSource.filter = '';
  }

  verTabla(tipo: string, element: any) {
    this.router.navigate(['/distributor/table-chats', tipo], {
      state: { data: element }
    });
  }

  openDetalle(element: any): void {
    const data = {
      action: "SEARCH_TELEFONO",
      telefono: element.telefono.substring(2)
    }

    this.sharedServices.postWhatsapp(data).subscribe(res => {
      this.sharedServices.chatWhat = res
      this.router.navigateByUrl(`/distributor/chat`);
    })
  }

  executeButtons(tipo: any) {

    switch (tipo) {
      case 7:
        this.cleanFilter();
        break;
      case 9:
        this.showFilters = !this.showFilters;
        break;

      default:
        console.warn(`Botón ${tipo} no tiene lógica definida`);
        break;
    }
  }

  cleanFilter(): void {
    this.filtrosComponent.limpiarFiltros();
    this.currentPayload = { action: 'INFO_MSN_WHATSAPP' };
    this.startAutoRefresh();
  }



  getDataNewFilter(filter: any[]): void {
    if (!filter.length) {
      this.currentPayload = { action: 'INFO_MSN_WHATSAPP' };
      this.startAutoRefresh();
      return;
    }

    const payload: any = {};

    filter.forEach((res: any) => {
      switch (res.id) {
        case 1:
          payload.action = 'SEARCH_IDCASO';
          payload.idCaso = res.value;
          break;
        case 2:
          payload.action = 'SEARCH_TELEFONO';
          payload.telefono = res.value;
          break;
        case 3:
          payload.action = 'SEARCH_NUMBERID';
          payload.numberId = res.value;
          break;
        case 4:
          payload.action = 'SEARCH_HABEASDATA';
          payload.habeasData = res.value === 'OK' ? '1' : '0';
          break;
      }
    });

    this.currentPayload = payload;
    this.startAutoRefresh();
  }


  filters(data: any): void {
    this.isLoading = true;

    this.sharedServices.postWhatsapp(data).subscribe({
      next: (res) => {
        // console.log('response:', res);

        if (Array.isArray(res)) {
          this.dataSource.data = res;
        } else if (res) {
          this.dataSource.data = [res];
        } else {
          this.dataSource.data = [];
          console.warn('El backend no retornó datos');
        }

      },

      error: (err) => {
        console.error('Error en postWhatsapp:', err);
        this.dataSource.data = [];
      },

      complete: () => {
        this.isLoading = false;

        // ✅ SIN setTimeout
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        if (this.paginator) {
          this.paginator.firstPage();
        }
      }
    });
  }


}
